import styled from 'styled-components';

import { media, themed } from '@/shared/ui/core';

export const FooterWrapper = styled.footer`
  background-color: ${themed('primary.accent')};
  margin-top: 7rem;
  padding-bottom: 5.625rem;

  @media ${media.desktopMin} {
    padding-bottom: 0;
  }
`;

export const FooterContent = styled.div`
  color: ${themed('primary.contrastText')};
  margin: 0 auto;
  max-width: 57.5rem;
  padding: 2.75rem 1.25rem;
  position: relative;

  svg.logo {
    display: block;
    height: 1.625rem;
    margin-bottom: 2rem;
    width: auto;
  }

  svg.fluff {
    height: 6.5625rem;
    position: absolute;
    top: -3.5rem;
    right: 0;

    g { clip-path: url(#ruffAndMuse) };
  }

  .Text {
    font-size: 0.875rem;

    & + p.Text {
      margin-top: 2rem;
    }

    a {
      font-size: 1rem;
      font-weight: 500;
      text-decoration: none;

      & + a::before {
        content: "-";
        margin: 0 0.5rem;
      }
    }
  }

  a {
    color: inherit;
  }
`;

export const NavLinks = styled.div`
  display: none;

  @media ${media.desktopMin} {
    display: block;
  }

  a {
    font-weight: 700;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    & + a {
      margin-left: 1rem;
    }
  }
`;

export const Divider = styled.div`
  background-color: ${themed('primary.contrastText')};
  height: 1px;
  margin: 2rem 0;
`;
